export const CustomerTagType: {
    RED_FLAG: "RED_FLAG";
    HIGH_VALUE: "HIGH_VALUE";
    REGULAR_CUSTOMER: "REGULAR_CUSTOMER";
    FAMILY_AND_FRIENDS: "FAMILY_AND_FRIENDS";
} = {
    RED_FLAG: "RED_FLAG",
    HIGH_VALUE: "HIGH_VALUE",
    REGULAR_CUSTOMER: "REGULAR_CUSTOMER",
    FAMILY_AND_FRIENDS: "FAMILY_AND_FRIENDS",
};

export type CustomerTagType = (typeof CustomerTagType)[keyof typeof CustomerTagType]